var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_136_447",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_136_447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2089 7.73328H5.20888C4.9511 7.73328 4.74666 7.52884 4.74666 7.27106V6.78217C4.74666 6.52439 4.9511 6.31995 5.20888 6.31995H19.2089C19.4667 6.31995 19.6711 6.52439 19.6711 6.78217V7.27106C19.6711 7.52884 19.4667 7.73328 19.2089 7.73328ZM19.2089 12.7111H5.20888C4.9511 12.7111 4.74666 12.5066 4.74666 12.2488V11.7599C4.74666 11.5022 4.9511 11.2977 5.20888 11.2977H19.2089C19.4667 11.2977 19.6711 11.5022 19.6711 11.7599V12.2488C19.6711 12.5066 19.4667 12.7111 19.2089 12.7111ZM19.2089 17.6888H5.20888C4.9511 17.6888 4.74666 17.4844 4.74666 17.2266V16.7377C4.74666 16.4799 4.9511 16.2755 5.20888 16.2755H19.2089C19.4667 16.2755 19.6711 16.4799 19.6711 16.7377V17.2266C19.6711 17.4844 19.4667 17.6888 19.2089 17.6888Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.31f0debab805e6f1e51179a8161181aa.svg";
export { ForwardRef as ReactComponent };